import Clients from "../../assets/images/Clients.svg";
import Users from "../../assets/images/Users.svg";
import Deals from "../../assets/images/CompDeals.svg";
import Leads from "../../assets/images/CompLeads.svg";
import Projects from "../../assets/images/CompProjects.svg";
import Customers from "../../assets/images/Customers.svg";
import HeaderDeal from "../../assets/images/Deal.svg";
import HeaderLead from "../../assets/images/Lead.svg";
import HeaderProjects from "../../assets/images/Projects.svg";
import Task from "../../assets/images/Task.svg";
import Integration from "../../assets/images/Integration.svg";
import Other from "../../assets/images/Other.svg";
import { getHexWithOpacity } from "../../utils/utilityFunctions/stringUtility";
import DocumentIcon from "../../utils/utilityFunctions/iconUtility";
import { Download } from "lucide-react";
import { useFetchCompanyDashboardDataQuery } from "../../utils/company/companyDashboard";
import LayoutHOC from "./../LayoutHOC";
import handlePostApi from "../../utils/api/postApiSlice";
import { useNavigate } from "react-router-dom";

const statsAttributes = {
  clients: {
    color: "#2D679E",
    icon: Clients,
  },
  users: {
    color: "#00B386",
    icon: Users,
  },
  deals: {
    color: "#7B7B7B",
    icon: Deals,
  },
  leads: {
    color: "#004EFF",
    icon: Leads,
  },
  projects: {
    color: "#22C55E",
    icon: Projects,
  },
};

const File = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="181" viewBox="0 0 327 181" fill="none" className="w-full">
      <path
        d="M253.556 90.0562C253.556 139.793 213.237 180.112 163.5 180.112C113.763 180.112 73.4438 139.793 73.4438 90.0562C73.4438 40.3195 113.763 0 163.5 0C213.237 0 253.556 40.3195 253.556 90.0562Z"
        fill="#F8FBFF"
      />
      <path
        d="M19.3327 33.9158C19.3327 32.0855 20.8166 30.6016 22.6469 30.6016H304.905C306.736 30.6016 308.22 32.0855 308.22 33.9158V146.046C308.22 147.876 306.736 149.36 304.905 149.36H22.6469C20.8165 149.36 19.3327 147.876 19.3327 146.046V33.9158Z"
        fill="#F2F8FE"
      />
      <path
        d="M0 56.5627C0 54.7324 1.48381 53.2486 3.31419 53.2486H323.686C325.516 53.2486 327 54.7324 327 56.5628V123.399C327 125.229 325.516 126.713 323.686 126.713H3.31418C1.48381 126.713 0 125.229 0 123.399V56.5627Z"
        fill="white"
      />
      <path
        d="M8.83788 64.7094C8.83788 63.2608 10.0122 62.0864 11.4609 62.0864H64.2132C65.6618 62.0864 66.8362 63.2608 66.8362 64.7094V115.252C66.8362 116.701 65.6618 117.875 64.2132 117.875H11.4609C10.0122 117.875 8.83788 116.701 8.83788 115.252V64.7094Z"
        fill="#E0F1FF"
      />
      <path
        d="M75.674 68.4386C75.674 64.9304 78.5179 62.0864 82.0262 62.0864H249.945C253.453 62.0864 256.297 64.9304 256.297 68.4386C256.297 71.9468 253.453 74.7908 249.945 74.7908H82.0262C78.5179 74.7908 75.674 71.9468 75.674 68.4386Z"
        fill="#E0F1FF"
      />
      <path
        d="M75.6739 89.9807C75.6739 86.4725 78.5179 83.6285 82.0261 83.6285H220.117C223.626 83.6285 226.469 86.4725 226.469 89.9807C226.469 93.489 223.626 96.3329 220.117 96.3329H82.0261C78.5179 96.3329 75.6739 93.489 75.6739 89.9807Z"
        fill="#F2F8FE"
      />
      <path
        d="M75.6739 111.523C75.6739 108.015 78.5179 105.171 82.0261 105.171H205.756C209.264 105.171 212.108 108.015 212.108 111.523C212.108 115.031 209.264 117.875 205.756 117.875H82.0261C78.5179 117.875 75.6739 115.031 75.6739 111.523Z"
        fill="#F2F8FE"
      />
    </svg>
  );
};

const InfoSvg = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2816_76870)">
        <path
          d="M7 0C3.13111 0 0 3.13075 0 7C0 10.8688 3.13075 14 7 14C10.8689 14 14 10.8693 14 7C14 3.13116 10.8693 0 7 0ZM7 13.0233C3.67877 13.0233 0.976746 10.3213 0.976746 7C0.976746 3.67875 3.67877 0.976746 7 0.976746C10.3212 0.976746 13.0233 3.67875 13.0233 7C13.0233 10.3213 10.3212 13.0233 7 13.0233Z"
          fill="#767676"
        />
        <path
          d="M7.00026 5.83496C6.58562 5.83496 6.29077 6.01007 6.29077 6.26806V9.77861C6.29077 9.99977 6.58562 10.2209 7.00026 10.2209C7.39647 10.2209 7.71894 9.99977 7.71894 9.77861V6.268C7.71894 6.01004 7.39647 5.83496 7.00026 5.83496Z"
          fill="#767676"
        />
        <path
          d="M7.00016 3.66992C6.57631 3.66992 6.24463 3.97398 6.24463 4.32412C6.24463 4.67429 6.57634 4.98756 7.00016 4.98756C7.41481 4.98756 7.74654 4.67429 7.74654 4.32412C7.74654 3.97398 7.41478 3.66992 7.00016 3.66992Z"
          fill="#767676"
        />
      </g>
      <defs>
        <clipPath id="clip0_2816_76870">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

function CompanyDashboard() {
  const { data: response } = useFetchCompanyDashboardDataQuery();
  const navigate = useNavigate();
  const data = response?.data;
  // const data = {
  //   stats: {
  //     clients: { total: 320, active: 150, inactive: 17, prospective: 10 },
  //     deals: { total: 30 },
  //     leads: { total: 12 },
  //     projects: { total: 10 },
  //     users: { totalUsers: 5, used: 3 },
  //   },

  //   pinnedModules: [
  //     {
  //       moduleName: "Module Name",
  //       totalRecords: 10,
  //       totalTasks: 12,
  //       notes:
  //         "We have a team of 295+ qualified bookkeepers with more than 5+ years of experience & with complete proficiency on US accounting...",
  //       updatedBy: "pallvi",
  //       date: "18 Dec 2024 05:58 PM",
  //     },
  //     {
  //       moduleName: "Module Name",
  //       totalRecords: 10,
  //       totalTasks: 12,
  //       notes:
  //         "We have a team of 295+ qualified bookkeepers with more than 5+ years of experience & with complete proficiency on US accounting...",
  //       updatedBy: "pallvi",
  //       date: "18 Dec 2024 05:58 PM",
  //     },
  //   ],

  //   documents: {
  //     files: [
  //       {
  //         name: "Project_Brief.pdf",
  //         uploadedAt: "18 Dec 2024 05:58 PM",
  //         uploadedBy: "khusdeer",
  //         type: "file",
  //       },
  //       {
  //         name: "Project_Brief.pdf",
  //         uploadedAt: "18 Dec 2024 05:58 PM",
  //         uploadedBy: "khusdeer",
  //         type: "file",
  //       },
  //     ],
  //   },

  //   notesSection: {
  //     notes: [
  //       {
  //         title: "Accounting Assistant",
  //         author: "Pallvi Pathania",
  //         date: "27 May, 11:30 AM",
  //         description:
  //           "We have a team Of 295+ qualified Bookkeeper With more Than 5+ Years Of Experience & With Complete Proficiency On US Accounting...",
  //         attachments: [{ name: "123.pdf", type: "pdf" }],
  //       },
  //       {
  //         title: "Accounting Assistant",
  //         author: "Pallvi Pathania",
  //         date: "27 May, 11:30 AM",
  //         description:
  //           "We have a team Of 295+ qualified Bookkeeper With more Than 5+ Years Of Experience & With Complete Proficiency On US Accounting...",
  //         attachments: [{ name: "123.pdf", type: "pdf" }],
  //       },
  //     ],
  //   },

  //   smartSuggestions: {
  //     suggestions: [
  //       {
  //         title: "How to add an account manually?",
  //         description: "We'll show you how to add an account manually.",
  //         cta: "Add account",
  //       },
  //       {
  //         title: "How to add an account manually?",
  //         description: "We'll show you how to add an account manually.",
  //         cta: "Add account",
  //       },
  //     ],
  //   },
  // };

  const defaultStats = {
    clients: {},
    deals: {},
    leads: {},
    projects: {},
    users: {},
  };
  const headers = [
    { label: "Customer", icon: Customers },
    { label: "Deal", icon: HeaderDeal },
    { label: "Lead", icon: HeaderLead },
    { label: "Project", icon: HeaderProjects },
    { label: "Task", icon: Task },
    { label: "Integration", icon: Integration },
    { label: "Other", icon: Other },
  ];

  const excludedStats = ["clients", "users"];

  const handleNavigateAddUser = () => {
    navigate("/setting/manage-access?user=add");
  };

  return (
    <div className="p-4 bg-white min-h-screen font-sans border rounded-xl">
      {/* Header Tabs */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex gap-2">
          {headers?.map((tab, i) => (
            <button
              key={i}
              className="px-4 py-1 border border-[#1313131A] rounded-full text-[#131313CC] text-sm font-medium hover:bg-gray-200 transition flex justify-center items-center gap-2"
            >
              <img src={tab.icon} alt={tab.label} />
              <span>{tab?.label}</span>
            </button>
          ))}
        </div>
        <button
          onClick={handleNavigateAddUser}
          className="px-4 py-2 text-[131313CC] border border-[#1313131A] rounded-full text-sm font-medium h-full flex justify-center items-center gap-2"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2714_73898)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.125 6.125H1.3125C0.8295 6.125 0.4375 6.517 0.4375 7C0.4375 7.483 0.8295 7.875 1.3125 7.875H6.125V12.6875C6.125 13.1705 6.517 13.5625 7 13.5625C7.483 13.5625 7.875 13.1705 7.875 12.6875V7.875H12.6875C13.1705 7.875 13.5625 7.483 13.5625 7C13.5625 6.517 13.1705 6.125 12.6875 6.125H7.875V1.3125C7.875 0.8295 7.483 0.4375 7 0.4375C6.517 0.4375 6.125 0.8295 6.125 1.3125V6.125Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_2714_73898">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>Add User</span>
        </button>
      </div>

      {/* Main Layout */}
      <div className="grid grid-cols-12 gap-6 mt-6">
        {/* Left Section */}
        <div className="col-span-8 space-y-6">
          {/* Upper 2 Divs */}
          <div className="grid grid-cols-2 gap-4">
            {/* Clients */}
            <div className="bg-white border p-4 rounded-lg flex flex-col gap-2">
              <div className="flex justify-between">
                <div className="flex gap-4 items-center">
                  <div
                    style={{ border: `1px solid ${getHexWithOpacity(statsAttributes.clients.color, 20)}` }}
                    className="w-14 h-14 rounded-full bg-white flex justify-center items-center"
                  >
                    <img src={statsAttributes.clients.icon} alt="clients" />
                  </div>
                  <div className="flex flex-col gap-1">
                    <h2 style={{ color: statsAttributes.clients.color }} className="text-2xl font-bold">
                      {data?.stats?.clients?.total || 0}
                    </h2>
                    <p className="text-gray-500 text-xs">No. of Clients</p>
                  </div>
                </div>
                {/* <span>↗️</span> */}
              </div>
              <div className="flex gap-2 mt-2 text-xs flex-wrap">
                <span className="px-3 py-1.5 bg-[#00B38614] text-[#00B386] rounded-full">
                  Active {data?.stats?.clients?.active || 0}
                </span>
                <span className="px-3 py-1.5 bg-[#E5252A14] text-[#E5252A] rounded-full">
                  Inactive {data?.stats?.clients?.inactive || 0}
                </span>
                <span className="px-3 py-1.5 bg-[#5F5F5F14] text-[#5F5F5F] rounded-full">
                  No. of Prospective {data?.stats?.clients?.prospective || 0}
                </span>
              </div>
            </div>

            {/* Users */}
            <div className="bg-white border p-4 rounded-lg flex flex-col gap-4">
              <div className="flex justify-between">
                <div className="flex gap-4 items-center">
                  <div
                    style={{ border: `1px solid ${getHexWithOpacity(statsAttributes.users.color, 20)}` }}
                    className="w-14 h-14 rounded-full bg-white flex justify-center items-center"
                  >
                    <img src={statsAttributes.users.icon} alt="users" />
                  </div>
                  <div className="flex flex-col gap-1">
                    <h2 style={{ color: statsAttributes.users.color }} className="text-2xl font-bold">
                      {data?.stats?.users?.totalUsers || 0}
                    </h2>
                    <p className="text-gray-500 text-xs">No. of Users</p>
                  </div>
                </div>
                <InfoSvg />
              </div>
              <hr className="bg-[#1313131A]" />
              <div className="text-xs text-[#1D4469CC] w-full flex items-center justify-between">
                <span>View Summary</span>
                <span>{`(${data?.stats?.users?.used || 0}/${data?.stats?.users?.totalUsers || 0} Total Users)`}</span>
              </div>
            </div>
          </div>

          {/* Another Three Divs */}
          <div className="grid grid-cols-3 gap-4">
            {Object.values(data?.stats || defaultStats)?.length > 0 &&
              Object.entries(data?.stats || defaultStats)
                ?.filter(([key, value]) => !excludedStats.includes(key))
                ?.map(([key, value]) => (
                  <div className="bg-white border p-4 rounded-lg flex items-center gap-4">
                    <div
                      style={{ border: `1px solid ${getHexWithOpacity(statsAttributes[key].color, 20)}` }}
                      className="w-14 h-14 rounded-full bg-white flex justify-center items-center"
                    >
                      <img src={statsAttributes[key].icon} alt="clients" />
                    </div>
                    <div className="flex flex-col gap-1">
                      <h2 style={{ color: statsAttributes[key].color }} className={`text-xl font-bold`}>
                        {value?.total || 0}
                      </h2>
                      <p className="text-sm font-medium text-[#13131399] capitalize">Total {key}</p>
                    </div>
                  </div>
                ))}
          </div>

          {/* Pinned Modules & Documents */}
          <div className="grid grid-cols-2 gap-6">
            {/* Pinned Modules */}
            <div className="bg-white shadow rounded-lg h-[580px] overflow-auto scrollbar-hidden relative">
              <h3 className="font-semibold text-lg text-[#131313CC] flex items-center gap-2 sticky top-0 border-b p-5">
                📌 Pinned Modules
              </h3>
              <div className="flex flex-col h-[500px] gap-5 p-5">
                {data?.pinnedModules?.length > 0 ? (
                  data?.pinnedModules?.map((m, i) => (
                    <div key={i} className="border-b border-dashed border-[#1313131A] pt-4 pb-5 flex flex-col gap-2">
                      <div className="w-full flex gap-2 justify-between">
                        <h4 className="font-semibold">{m?.moduleName}</h4>
                        <div className="flex gap-4 items-center">
                          <span className="text-sm text-[#13131399]">
                            Total Records <span className="text-[#131313CC] font-medium">{m?.totalRecords}</span>
                          </span>
                          <span className="text-sm text-[#13131399]">
                            Tasks <span className="text-[#131313CC] font-medium">{m?.totalTasks}</span>
                          </span>
                        </div>
                      </div>
                      <p className="text-sm leading-relaxed">{m?.notes}</p>
                      <p className="text-xs text-gray-400">
                        {m?.date} - By {m?.updatedBy}
                      </p>
                    </div>
                  ))
                ) : (
                  <div className="h-full flex justify-center items-center">
                    <File />
                  </div>
                )}
              </div>
            </div>

            {/* Documents */}
            <div className="bg-white shadow rounded-lg h-[580px] overflow-auto scrollbar-hidden relative">
              <h3 className="font-semibold text-lg text-[#131313CC] flex items-center gap-2 sticky top-0 border-b p-5">
                📄 Documents
              </h3>
              <div className="flex flex-col gap-5 p-5 h-[500px]">
                {data?.documents?.files?.length > 0 ? (
                  data?.documents?.files?.map((doc, i) => (
                    <div
                      key={i}
                      className="border-b border-dashed border-[#1313131A] rounded-md p-4 pb-5 flex flex-col gap-2 hover:bg-blue-50 transition group"
                    >
                      <div className="w-full flex justify-between gap-2">
                        <div className="flex gap-2">
                          <DocumentIcon type={doc?.type} filename={doc?.name} />
                          <span className="text-sm text-[#666666]">{doc?.name}</span>
                        </div>
                        <div className="flex items-center gap-3 opacity-0 group-hover:opacity-100 transition-opacity">
                          <button className="p-1 text-green-400 hover:text-green-500">
                            <Download
                              size={16}
                              // onClick={(e) => {
                              //   e.stopPropagation();
                              //   window.open(doc.access_sas_link);
                              // }}
                            />
                          </button>
                        </div>
                      </div>
                      <span className="text-xs text-gray-500 mt-1">
                        {doc?.uploadedAt} - By {doc?.uploadedBy}
                      </span>
                    </div>
                  ))
                ) : (
                  <div className="h-full flex items-center justify-center">
                    <File />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="col-span-4 space-y-6 h-[838px]">
          {/* Notes */}
          <div className="bg-white shadow rounded-lg h-[550px] overflow-auto scrollbar-hidden relative">
            <h3 className="font-semibold mb-3 p-5 border-b sticky top-0">{`📝 Notes (${data?.notesSection?.notes?.length})`}</h3>
            <div className="flex flex-col gap-5 p-5 h-[470px]">
              {data?.notesSection?.notes?.length > 0 ? (
                data?.notesSection?.notes?.map((note, i) => (
                  <div key={i} className="px-4">
                    <div className="font-medium text-lg text-[#383838]">{note?.title}</div>
                    <div className="text-xs text-[#666666B2]">
                      {note?.author} | {note?.date}
                    </div>
                    <p className="mt-2 text-xs text-[#131313CC] leading-relaxed">{note?.description}</p>
                    <div className="flex gap-2 mt-3 flex-wrap">
                      {note?.attachments?.map((a, idx) => (
                        <div
                          key={idx}
                          className="px-4 py-2 bg-[#13131305] rounded-full text-xs flex items-center gap-1"
                        >
                          <DocumentIcon type={a?.type} filename={a?.name} />
                          <span>{a?.name}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              ) : (
                <div className="h-full flex justify-center items-center">
                  <File />
                </div>
              )}
            </div>
          </div>

          {/* Smart Suggestions */}
          <div className="bg-white shadow rounded-lg h-[265px] overflow-auto scrollbar-hidden relative">
            <h3 className="font-semibold mb-3 p-5 sticky top-0 border-b border-dashed text-[#131313CC] text-lg">
              💡 Smart Suggestions
            </h3>
            <div className="flex flex-col gap-5 px-5 pb-5 pt-2 h-[185px]">
              {data?.smartSuggestions?.suggestions?.length > 0 ? (
                data?.smartSuggestions?.suggestions?.map((s, i) => (
                  <div key={i} className="px-5">
                    <div className="font-medium text-sm text-[#131313CC]">{s?.title}</div>
                    <p className="text-xs text-[#131313CC] mt-1 leading-relaxed">{s?.description}</p>
                    <button className="mt-3 text-blue-600 hover:underline text-sm">+ {s?.cta}</button>
                  </div>
                ))
              ) : (
                <div className="h-full flex items-center justify-center">
                  <File />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default LayoutHOC(CompanyDashboard);
